import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import 'vuetify/src/stylus/app.styl'
import es from 'vuetify/es5/locale/es'

Vue.config.productionTip = false
Vue.use(Vuetify, {
  iconfont: 'md',
  lang: {
    locales: { es },
    current: 'es'
  },
  options: {
    customProperties: true
  },
  theme: {
    'blue-Primary': '#004250',
    'blue-primary-95': '#0D4B59',
    'blue-secondary': '#006176',
    'light-blue-menu': '#CBDEE0',
    'button-primary-hover': '#4DB897',
    'button-secondary': '#88A09E',
    'button-secondary-hover': '#708382',
    'text-primary': '#203242',
    background: '#F5F5F5',
    'background-grey': '#FAFAFA',
    'text-secondary': '#6F6F6F',

    'background-warning': '#FCAB10',
    'background-success': '#54CAA6',
    'background-error': '#F1C0B7',

    white: '#FFFFFF',
    lightBlueMenu: '#CBDEE0',
    blueSecondary: '#006176',
    bluePrimary: '#2470A0',
    bluePrimary95: '#0D4B59',
    checkbox: '#3A9AA3',
    buttonPrimary: '#4f41a3',
    buttonPrimaryOver: '#898DFF',
    buttonSecondary: '#E4527F',
    buttonSecondaryOver: '#EC96B0',
    textPrimary: '#4F4F4F',
    textSecondary: '#6F6F6F',
    success: '#44AF69',
    successBackground: '#B4DFC3',
    errorBackground: '#F1C0B7',
    warning: '#FCAB10',
    warningText: '#D39011',
    dargerEllipse: '#EB5757',
    noImg: '#f16b6c',
    successEllipse: '#44AF69',
    grayFont: '#969696',
    secondaryOverLight: '#c3c3c3',
    pendingEllipse: '#FCAB10',
    progressEllipse: '#0091B0',
    warningEllipse: '#FCAB10',
    pinkPrimary: '#fd8db0',
    aquaPrimary: '#5cd6dd',
    lightGreen: '#d7e7ab',

    // "Header"              : "#58a8af",
    // "gradientHeader2"      : "to bottom, #2470a0, #237fa6, #2f8daa, #429bad, #58a8af",
    // "gradientHeader"       : "to bottom, rgb(36,112,160), rgb(35,127,166), rgb(47,141,170), rgb(66,155,173), rgb(88,168,175)",

    primary: '#4F41A3',
    secondary: '#424242',
    accent: '#FF5252',
    error: '#FF5252',
    info: '#2196F3'
  }
})